import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { TextField, CircularProgress, Typography } from "@mui/material";

const EditSubSkillDialog = ({
  open,
  handleClose,
  subSkillData,
  handleSubmit,
  loading,
}) => {
  const [subSkill, setSubSkill] = useState({
    name: "",
    subSkillid: null,
  });

  useEffect(() => {
    setSubSkill({
      ...subSkillData,
    });
  }, [subSkillData]);

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Edit Subskill</DialogTitle>
      <DialogContent>
        <TextField
          size="small"
          value={subSkill.name}
          onChange={(e) =>
            setSubSkill({
              ...subSkill,
              name: e.target.value,
            })
          }
          variant="outlined"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          Cancel
        </Button>
        <Button onClick={() => handleSubmit(subSkill)} disabled={loading}>
          {loading ? <CircularProgress /> : <Typography>Save</Typography>}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditSubSkillDialog;
